import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { PremiumComparisonActions } from ".";
import { initialPremiumComparisonState } from "./premiumComparison.types";
import { CLEAR_PREMIUM_COMPARISON_STATE, FETCH_PREMIUM_COMPARISON_LIST_FAILED, FETCH_PREMIUM_COMPARISON_LIST_PROGRESS, FETCH_PREMIUM_COMPARISON_LIST_SUCCESS } from "./premiumComparisonActions";



export const premiumComparisonReducer = (
  state: IStoreState["premiumComparison"] = initialPremiumComparisonState,
  action: PremiumComparisonActions
) => {
  switch (action.type) {
    
    case FETCH_PREMIUM_COMPARISON_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_PREMIUM_COMPARISON_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = list;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_PREMIUM_COMPARISON_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case CLEAR_PREMIUM_COMPARISON_STATE: {
      const newState = produce(state, (draftState)=>{
        draftState.loading = LoadState.NotLoaded;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState
    }

    default: {
      return state;
    }
  }
};
